export const formatToCurrency = (number: number) => {
  return "$ " + number.toLocaleString("en-US");
};
